module.exports = __webpack_public_path__ + "static/ai-poster-1-0cd982d6fd9407c0f271c8da5c85e8b0.png";